import { handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUpserters } from '../core';
import * as actions from './investmentTWRRActions';

const investmentTWRRReducer = handleActions(
  {
    [actions.getInvestmentTWRR]: (state) => state.merge({ isLoading: true }),
    //  TODO: Ask QCS to fix it so we do not need to destroy old data and start fresh
    [actions.getInvestmentTWRRSuccess]: (state, { payload }) =>
      resourceUpserters.upsertResources(state, payload.merge({ replaceCollection: true })),
    [actions.getInvestmentTWRRFailure]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),
  },
  resourceStoreTypes.mkQcsSyncResourceStore(),
);

export const INVESTMENT_TWRR_REDUCER_KEY = 'investmentTWRRStore';
export default investmentTWRRReducer;
